import { useTranslation } from "react-i18next";
import NewPage from "../../../layouts/page/NewPage";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useState } from "react";
import { convertBooleanToStatus } from "../../../../utils/ConverterUtils";
import MenuConfig from "../../../../constants/MenuConfig";
import Form from "./Form";
import { getId, sendToApi } from "../../../../utils/ApiUtils";
import { useNavigate } from "react-router-dom";
import Api from "../../../../constants/Api";
import { ApiError } from "../../../components/Common/ApiError";

const CategoryNew = () => {
    
    const { t } = useTranslation();
    const [status, setStatus] = useState(true);
    // Nasce comissionando: o veto é a exceção (água, chiclete), não a regra.
    const [commissionable, setCommissionable] = useState(true);
    const [entityData, setEntityData] = useState(null);
    const navigate = useNavigate();

    // Define o schema de validação do form.
    const formSchema = Yup.object().shape({
        name: Yup.string()
            .min(3, t("validation.min.generic", { field: t('name'), qty: 3 }))
            .required(t('validation.required.name'))
    });

    function onReset() {
        formik.resetForm({
            values: {
                name: ''
            }
        });
        setStatus(true);
        setCommissionable(true);
    }

    // Define o formik.
    const formik = useFormik({
        initialValues: {
            name: ''
        },
        validationSchema: formSchema,
        onSubmit: values => {
            let payload = {
                id: getId(entityData),
                name: values.name,
                commissionable: commissionable,
                status: convertBooleanToStatus(status)
            }
            
            // Aciona a api
            sendToApi(Api.main.category, payload, () => {
                if(entityData == null) {
                    onReset();
                } else {
                    navigate(MenuConfig.main.category.route);
                }
            }, (error) => {
                ApiError(error);
                formik.setSubmitting(false);
            });
        },
    });

    // Valida o form e em seguida submete os dados. Aciona o onSubmit do formik.
    const onSubmit = (e) => {
        e.preventDefault();
        formik.handleSubmit();
    }

    return (
        <>
            <NewPage
                motherMenu={t('main')}
                childMenu={t('categories')}
                activeMenu={t('new')}
                child={<Form formik={formik} status={status} setStatus={setStatus}
                    commissionable={commissionable} setCommissionable={setCommissionable}
                    entityData={entityData}/>}
                setEntityData={setEntityData}
                path={Api.main.category}
                isSubmitting={formik.isSubmitting}
                handleSubmit={onSubmit}
                cancelRoute={MenuConfig.main.category.route}
            />
        </>
    );
}

export default CategoryNew;
